import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import { Input } from 'components/universal/input';
import InputPasswodHideAndShow from 'components/universal/input-passwod-hide-and-show';
import Paragraph from 'components/universal/paragraph';
import { PATHS, ROUTES } from 'constants/routes';
import { Link } from 'react-router-dom';
import cls from './registration.module.scss';
import { useRegistrationEmployee } from './useRegistrationEmployee';
import { PASSWORD_ADNOTATION } from 'constants/validation-error-messages';

export interface IPasswordUpdateFormValues {
    new_password: string;
    new_password_repeat: string;
}

export interface IRegistrationFormValues {
    login: string;
    password: string;
}

export const RegistrationEmployeeView = () => {
    const {
        isAuthenticated,
        handleSubmitChange,
        onSubmitResetPassword,
        showNewPasswordHandle,
        showPasswordHandleSecond,
        onSubmitLogin,
        register,
        handleSubmit,
        showPasswordHandle,
        registerChange,
        changeErrors,
        showPassword,
        showPasswordSecond,
        t,
        loginErrors,
        showNewPassword
    } =  useRegistrationEmployee();

    if (isAuthenticated) {
        return (
            <div className={cls.containerChange}>
                <Heading
                    className={cls.headingChange}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('passwordUpdate.title')}
                </Heading>
                <Paragraph
                    className={cls.descriptionChange}
                    >
                    {t('passwordUpdate.description')}
                </Paragraph>
                <form className={cls.formChange} onSubmit={handleSubmitChange(onSubmitResetPassword)}>
                    <InputPasswodHideAndShow
                        onClick={showNewPasswordHandle}
                    >
                        <Input
                            className={`${cls.inputChange} mb-5`}
                            register={registerChange}
                            id="new_password"
                            name="new_password"
                            label={t('passwordUpdate.newPassword')}
                            error={t(changeErrors.new_password?.message)}
                            maxLength={255}
                            type={!showNewPassword ? 'password' : 'text'}
                            adnotation={t(PASSWORD_ADNOTATION)}
                        />
                    </InputPasswodHideAndShow>
                    <InputPasswodHideAndShow
                        onClick={showPasswordHandleSecond}
                    >
                        <Input
                            className={`${cls.inputChange} mb-6`}
                            register={registerChange}
                            id="new_password_repeat"
                            name="new_password_repeat"
                            label={t('passwordUpdate.repeatPassword')}
                            error={t(changeErrors.new_password_repeat?.message)}
                            maxLength={255}
                            type={!showPasswordSecond ? 'password' : 'text'}
                        />
                    </InputPasswodHideAndShow>
                    <div className={cls.buttonWrapperChange}>
                        <Button className="mx-auto mb-4" type="submit">
                            {t('passwordUpdate.button')}
                        </Button>
                    </div>
                </form>
                <Link
                    to={PATHS.HOME}
                    className={cls.linkChange}
                >
                    {t('passwordUpdate.skip')}
                </Link>
            </div>
        )
    }

    return (
        <div className={cls.container}>
            <div className={cls.columnLeft}>
                <Heading
                    className={cls.heading}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('registration.title')}
                </Heading>
                <Paragraph 
                    className={`${cls.paragraph} mb-10`}
                >
                    {t('registration.registrationEmployeeDesc')}
                </Paragraph>
                <form onSubmit={handleSubmit(onSubmitLogin)}>
                    <div className={cls.formFields}>
                        <Input
                            className={`${cls.inputCustomV2}`}
                            register={register}
                            id="login"
                            name="login"
                            label={t('logIn.login')}
                            error={t(loginErrors.login?.message)}
                            maxLength={255}
                        />
                        <InputPasswodHideAndShow
                            className={`${cls.inputCustomV2}`}
                            onClick={showPasswordHandle}
                        >
                            <Input
                                className={`${cls.inputCustom} mb-6`}
                                register={register}
                                id="password"
                                name="password"
                                label={t('logIn.temporaryPassword')}
                                error={t(loginErrors.password?.message)}
                                maxLength={255}
                                type={!showPassword ? 'password' : 'text'}
                            />
                        </InputPasswodHideAndShow>
                    </div>
                    <div className={cls.buttonWrapper}>
                        <Link to={ROUTES.REGISTER_CHOOSE.path}>
                            <Button 
                                className={`${cls.button} mx-auto mb-5`} 
                                styleType="border"
                                type="button"
                            >
                                {t('resetPassword.goBackButton')}
                            </Button>
                        </Link>
                        <Button className={cls.button} type="submit">
                            {t('logIn.next')}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};
